import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  getStepsForUser,
  getUser,
} from '../selectors'
import { initializeNodes } from '../../core/actions'
import AdminLayout from '../components/adminLayout'

const mapStateToProps = state => ({
  steps: getStepsForUser(state),
  user: getUser(state),
})

const mapDispatchToProps = dispatch => ({
  initialize: () => dispatch(initializeNodes()),
})

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AdminLayout)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminLayout.js